import { render } from "./Purchase_Report.vue?vue&type=template&id=6424ffda"
import script from "./Purchase_Report.vue?vue&type=script&lang=js"
export * from "./Purchase_Report.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__